export default __webpack_public_path__ + "static/media/css3.a79b97e7.svg";